import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { GlobalSearchPalette } from './GlobalSearchPalette';

interface GlobalSearchContextValue {
  openSearch: () => void;
  closeSearch: () => void;
}

const GlobalSearchContext = createContext<GlobalSearchContextValue>({
  openSearch: () => {},
  closeSearch: () => {},
});

export const useGlobalSearchContext = () => useContext(GlobalSearchContext);

export function GlobalSearchProvider({ children }: { children: React.ReactNode }) {
  const [open, setOpen] = useState(false);

  const openSearch = useCallback(() => setOpen(true), []);
  const closeSearch = useCallback(() => setOpen(false), []);

  useEffect(() => {
    function handleKeyDown(e: KeyboardEvent) {
      if ((e.ctrlKey || e.metaKey) && e.key === 'k') {
        e.preventDefault();
        setOpen((prev) => !prev);
      }
    }
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);

  return (
    <GlobalSearchContext.Provider value={{ openSearch, closeSearch }}>
      {children}
      <GlobalSearchPalette open={open} onClose={closeSearch} />
    </GlobalSearchContext.Provider>
  );
}
